import { LwApiPM } from "@techniaorg/liteweb-api";
import { modelPathOnServer, waitForIFrame } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrame(myframe)
  .then((api) => {
    LwAPI = api;
    LwAPI?.registerOnSelection((selectedItem) => {
      if (selectedItem != null) {
        const outputElement = document.getElementById(
          "output"
        ) as HTMLTextAreaElement;
        if (outputElement !== null) {
          outputElement.value = JSON.stringify(selectedItem, null, 2);
        }
      }
    });
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

let capt: any;
const exampleUrl = modelPathOnServer + "Measurement.jt";

function ex_addmodel() {
  LwAPI?.addModel(exampleUrl).then((result) => {
    if (result.error !== null) alert(result.msg);
  });
}

function ex_addpoints() {
  var coords = [
    130, 20, 20, 70, -20, 30, -40, -20, 30, 50, -90, 28.4, 70, 20, 0,
  ];

  var ids = ["point1", "point2", "point3", "point4", "point5"];

  var color = [1, 0, 0];
  var radius = 3.0;

  LwAPI?.addPoints(
    coords,
    color[0],
    color[1],
    color[2],
    radius,
    ids,
    exampleUrl
  );
}

function ex_getcap() {
  // Get capture
  LwAPI?.getCaptureWithPoints().then((cap) => {
    capt = cap;
  });
}

function ex_pointsalert() {
  if (capt.hasOwnProperty("points")) {
    var str = "Point IDs:\n";
    capt.points.forEach(function (pt: any) {
      str = str + "\n" + pt.id;
    });
    window.alert(str);
  }
}

function ex_screenshotdisp() {
  if (capt.hasOwnProperty("image")) {
    const captElement = document.getElementById("capt");
    if (captElement !== null) {
      captElement.setAttribute("src", capt.image);
    }
  }
}

function ex_topview() {
  LwAPI?.setView(1);
}

function ex_camerarestore() {
  if (capt.hasOwnProperty("camera")) {
    LwAPI?.setCamera(capt.camera);
  }
}

// Bind functions to buttons
document.getElementById("addModel")?.addEventListener("click", async () => {
  await apiReady;
  ex_addmodel();
});
document.getElementById("addPoints")?.addEventListener("click", async () => {
  await apiReady;
  ex_addpoints();
});
document.getElementById("getCap")?.addEventListener("click", async () => {
  await apiReady;
  ex_getcap();
});
document.getElementById("pointsAlert")?.addEventListener("click", async () => {
  await apiReady;
  ex_pointsalert();
});
document
  .getElementById("screenshotDisp")
  ?.addEventListener("click", async () => {
    await apiReady;
    ex_screenshotdisp();
  });
document.getElementById("topView")?.addEventListener("click", async () => {
  await apiReady;
  ex_topview();
});
document.getElementById("cameraRestore")?.addEventListener("click", async () => {
  await apiReady;
  ex_camerarestore();
});
